<template>
    <dx-data-grid
        :data-source="dataSource"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :width="'100%'"
        :column-min-width="120"
        :word-wrap-enabled="true"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />

        <dx-column
            caption="Id объекта"
            data-field="objectId"
            data-type="string"
        />

        <dx-column
            caption="Объект"
            data-field="description"
            data-type="string"
        />

        <dx-column
            caption="Удельная стоимость (руб)"
            data-field="value"
            data-type="numeric"
        >
            <dx-format
                type="fixedPoint"
                :precision="2"
            />
        </dx-column>

        <dx-column
            v-for="(column, index) in columns"
            :key="index"
            :caption="column.description"
            :data-field="`character__${column.kod_character}`"
            data-type="string"
            :min-width="200"
            cell-template="cellTemplate"
        >
        </dx-column>

        <dx-master-detail
            :enabled="true"
            template="masterDetailTemplate"
        />

        <template #masterDetailTemplate="{ data: row }" >
            <arki-work-component
                style="padding: -15px"
                :data-source="row.data.works"
            ></arki-work-component>
        </template>

        <template #cellTemplate="{ data: cell }">
            <span>{{ cell.data[cell.column.dataField]?.value }}</span>
            <div v-if="cell.data[cell.column.dataField]?.prValue">
                <span class="character-prev-value">{{ cell.data[cell.column.dataField]?.prValue }}</span>
            </div>
        </template>

    </dx-data-grid>
</template>

<script>
export default {
    name: 'arki-project-object-component',
};
</script>

<script setup>
import { defineProps } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxLoadPanel,
    DxSorting,
    DxMasterDetail,
    DxFormat
} from 'devextreme-vue/data-grid'

import ArkiWorkComponent from '@/views/arki/views/request/project/arki-work-component.vue';

const { dataSource, columns } = defineProps({
    dataSource: Array,
    columns: Array
})

</script>

<style lang="scss" scoped>
@import '@/themes/generated/variables.base.scss';

.character-prev-value {
    color: $base-accent;
}

:deep(.dx-master-detail-cell) {
    padding: 1px !important;
}

</style>
